var _g, _path, _g2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 106,
    viewBox: "0 0 83 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1198_2450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 3H22C13.0433 3 8.56497 3 5.78249 5.78249C3 8.56497 3 13.0433 3 22V72.2938C3 86.9433 3 94.268 7.62007 97.0341C7.79822 97.1407 7.97982 97.2415 8.16457 97.3363C12.9559 99.7937 19.1719 95.9188 31.6037 88.1691C36.339 85.2172 38.7067 83.7413 41.3369 83.6961C41.4456 83.6942 41.5544 83.6942 41.6631 83.6961C44.2933 83.7413 46.661 85.2172 51.3963 88.1691C63.8282 95.9188 70.0441 99.7937 74.8354 97.3363C75.0202 97.2415 75.2018 97.1407 75.3799 97.0341C80 94.268 80 86.9433 80 72.2938V22C80 13.0433 80 8.56497 77.2175 5.78249C74.435 3 69.9567 3 61 3Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 11.5H27V98.5L42 89.5L57 98.5V11.5Z",
    fill: "#FAC900"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_1198_2450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 7H20C13.8717 7 10.8076 7 8.90381 8.90381C7 10.8076 7 13.8717 7 20V76.4828C7 86.8778 7 92.0753 10.3554 93.9301C13.7107 95.7849 18.112 93.0204 26.9146 87.4914L34.5854 82.6733C37.9471 80.5617 39.628 79.506 41.5 79.506C43.372 79.506 45.0529 80.5617 48.4146 82.6733L56.0854 87.4914C64.888 93.0204 69.2893 95.7849 72.6446 93.9301C76 92.0753 76 86.8778 76 76.4828V20C76 13.8717 76 10.8076 74.0962 8.90381C72.1924 7 69.1283 7 63 7Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 18.5L46.6157 27.7707L57.168 30.2467L50.0864 38.4523L50.9923 49.2533L41 45.054L31.0077 49.2533L31.9136 38.4523L24.832 30.2467L35.3843 27.7707L41 18.5Z",
    fill: "#FAC900"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1198_2450",
    x: 0.75,
    y: 0.75,
    width: 81.5,
    height: 101.07,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.168 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1198_2450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.084 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1198_2450",
    result: "effect2_dropShadow_1198_2450"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1198_2450",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_1198_2450",
    x: 4.75,
    y: 4.75,
    width: 73.5,
    height: 93.5039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.168 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1198_2450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.084 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1198_2450",
    result: "effect2_dropShadow_1198_2450"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1198_2450",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.8d048e4fd6f9e720e26c724f421adfaa.svg";
export { ForwardRef as ReactComponent };